@if (!rows.length) {
    <p class="empty">None of these have any {{fieldName}} to add up.</p>
} @else {
    <p class="pareto-headline">
        <b>{{coreCount}} of {{count}}</b> make up {{coreCount === rows.length ? 'all' : '80%'}} of the {{fieldName}} ({{value(total, false)}}).
        @if (shown.length < rows.length) { The {{rows.length - shown.length}} smallest aren't shown. }
    </p>
    <div class="chart-legend" aria-label="What the colours mean">
        <span class="legend-item"><span class="swatch" [style.background]="typeData.colour"></span>The few that make up 80%</span>
        <span class="legend-item"><span class="swatch faded" [style.background]="typeData.colour"></span>The rest</span>
        <span class="legend-note">Each label is the value, then the running total</span>
    </div>
    <div class="chart-box" [style.height.px]="height">
        <canvas baseChart [type]="'bar'" [datasets]="datasets" [labels]="labels" [options]="options" [plugins]="plugins" (chartClick)="onClick($event)"
            role="img" [attr.aria-label]="coreCount + ' of ' + count + ' make up 80% of the ' + fieldName"></canvas>
    </div>
}
